(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-cn-carousel]').forEach((root) => {
    const slides = [...root.querySelectorAll('.cn-hero__slide')];
    const dots = [...root.querySelectorAll('[data-cn-dot]')];
    if (!slides.length) return;
    let index = slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (index < 0) index = 0;
    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    };
    root.querySelector('[data-cn-prev]')?.addEventListener('click', () => show(index - 1));
    root.querySelector('[data-cn-next]')?.addEventListener('click', () => show(index + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
    if (!reduceMotion && slides.length > 1) window.setInterval(() => show(index + 1), 7000);
  });

  document.querySelectorAll('[data-cn-product-gallery]').forEach((root) => {
    const images = [...root.querySelectorAll('[data-cn-gallery-image]')];
    const dots = [...root.querySelectorAll('[data-cn-gallery-dot]')];
    if (images.length < 2) return;
    let index = images.findIndex((image) => image.classList.contains('is-active'));
    if (index < 0) index = 0;
    const show = (next) => {
      index = (next + images.length) % images.length;
      images.forEach((image, i) => image.classList.toggle('is-active', i === index));
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    };
    root.querySelector('[data-cn-gallery-prev]')?.addEventListener('click', () => show(index - 1));
    root.querySelector('[data-cn-gallery-next]')?.addEventListener('click', () => show(index + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
  });
})();
